export class ParamThemeResponse {
    logo: string;
    cssText: string;
}
